/**
 * Homepage: Baseline to Blueprint (BTB) carousel — requires jQuery + Slick.
 */
(function ($) {
  'use strict';
  $(function () {
    var $btbSlides = $('#BTB_Slides');
                    var $btbNav = $('#BTB_NavDots');
                    var $btbMobileTrack = $('#BTB_MobileTrack');
                    var $btbMobileDots = $('#BTB_MobileDots .BTB_MobileDot');
    
                    function isBTBMobileViewport() {
                        return window.matchMedia('(max-width: 749px)').matches;
                    }
    
                    var slideDurationsMs_3 = [7000, 7000, 7000];
                    var tickMs_3 = 10;
                    var percentTime_3 = 0;
                    var activeSlideIndex_3 = 0;
                    var isPausedByUser_3 = false;
                    var pausedToggleIndex_3 = null;
                    var theTick_3 = null;
                    var btbMode = null;
    
                    function destroyBTBCarousel() {
                        if ($btbSlides.hasClass('slick-initialized')) {
                            $btbSlides.slick('unslick');
                        }
                        if ($btbNav.hasClass('slick-initialized')) {
                            $btbNav.slick('unslick');
                        }
                        if (theTick_3) {
                            clearInterval(theTick_3);
                            theTick_3 = null;
                        }
                        $btbSlides.off('.btbDesktop');
                        $btbNav.off('.btbDesktop');
                    }
    
                    function getActiveBar_3() {
                        return $('#BTB_NavDots .BTB_ND_Tab').eq(activeSlideIndex_3).find('.ND_Progress');
                    }
    
                    function getCurrentDurationMs_3() {
                        return slideDurationsMs_3[activeSlideIndex_3] || 7000;
                    }
    
                    function resetProgressbar_3() {
                        $('#BTB_NavDots .ND_Progress').css({ height: '0%' });
                        if (theTick_3) {
                            clearInterval(theTick_3);
                            theTick_3 = null;
                        }
                    }
    
                    function startProgressbar_3() {
                        if (isBTBMobileViewport()) {
                            return;
                        }
                        resetProgressbar_3();
                        percentTime_3 = 0;
    
                        if (isPausedByUser_3) {
                            getActiveBar_3().css({ height: '100%' });
                            $btbSlides.slick('slickPause');
                            return;
                        }
    
                        theTick_3 = setInterval(theInterval_3, tickMs_3);
                        $btbSlides.slick('slickPlay');
                    }
    
                    function pauseProgressbar_3(clickedIndex_3) {
                        isPausedByUser_3 = true;
                        pausedToggleIndex_3 = clickedIndex_3;
                        if (theTick_3) {
                            clearInterval(theTick_3);
                            theTick_3 = null;
                        }
                        getActiveBar_3().css({ height: '100%' });
                        $btbSlides.slick('slickPause');
                    }
    
                    function resumeProgressbar_3() {
                        if (!isPausedByUser_3) {
                            return;
                        }
    
                        isPausedByUser_3 = false;
                        pausedToggleIndex_3 = null;
                        resetProgressbar_3();
                        theTick_3 = setInterval(theInterval_3, tickMs_3);
                        $btbSlides.slick('slickPlay');
                    }
    
                    function theInterval_3() {
                        if (isBTBMobileViewport()) {
                            return;
                        }
                        var currentDurationMs_3 = getCurrentDurationMs_3();
                        var activeBar_3 = getActiveBar_3();
    
                        percentTime_3 += (tickMs_3 / currentDurationMs_3) * 100;
                        activeBar_3.css({ height: percentTime_3 + '%' });
    
                        if (percentTime_3 >= 100) {
                            $btbSlides.slick('slickNext');
                        }
                    }
    
                    function initBTBDesktop() {
                        $btbSlides.slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            fade: true,
                            asNavFor: '#BTB_NavDots',
                            autoplay: true,
                            autoplaySpeed: 10000,
                            infinite: true,
                            centerMode: true,
                        });
                        $btbNav.slick({
                            infinite: false,
                            slidesToShow: 10,
                            asNavFor: '#BTB_Slides',
                            dots: false,
                            centerMode: false,
                            centerPadding: '60px',
                            vertical: true,
                            verticalSwiping: true,
                            focusOnSelect: true,
                        });
    
                        $btbSlides.on('beforeChange.btbDesktop', function(event, slick, currentSlide, nextSlide) {
                            activeSlideIndex_3 = nextSlide;
                            startProgressbar_3();
                        });
    
                        $btbNav.on('click.btbDesktop', '.BTB_ND_Title', function() {
                            var clickedIndex_3 = parseInt($(this).closest('.BTB_ND_Tab').attr('data-slick-index'), 10);
                            if (isNaN(clickedIndex_3)) {
                                clickedIndex_3 = $(this).closest('.BTB_ND_Tab').index();
                            }
    
                            if (isPausedByUser_3) {
                                if (clickedIndex_3 === pausedToggleIndex_3) {
                                    resumeProgressbar_3();
                                } else {
                                    pausedToggleIndex_3 = clickedIndex_3;
                                }
                            } else {
                                pauseProgressbar_3(clickedIndex_3);
                            }
                        });
    
                        activeSlideIndex_3 = 0;
                        startProgressbar_3();
                    }
    
                    function initBTBMobile() {
                        function setActiveDot(index) {
                            $btbMobileDots.removeClass('is-active');
                            $btbMobileDots.eq(index).addClass('is-active');
                        }
    
                        function getClosestIndex() {
                            if (!$btbMobileTrack.length) return 0;
                            var stateWidth = $btbMobileTrack.outerWidth() || 1;
                            var idx = Math.round($btbMobileTrack.scrollLeft() / stateWidth);
                            return Math.max(0, Math.min(2, idx));
                        }
    
                        $btbMobileTrack.off('.btbMobile').on('scroll.btbMobile', function() {
                            setActiveDot(getClosestIndex());
                        });
    
                        $btbMobileDots.off('.btbMobile').on('click.btbMobile', function() {
                            var idx = parseInt($(this).attr('data-btb-mobile-dot'), 10) || 0;
                            var stateWidth = $btbMobileTrack.outerWidth() || 1;
                            $btbMobileTrack.stop().animate({ scrollLeft: idx * stateWidth }, 250);
                            setActiveDot(idx);
                        });
    
                        setActiveDot(0);
                        if ($btbMobileTrack.length) {
                            $btbMobileTrack.scrollLeft(0);
                        }
                    }
    
                    function routeBTBCarousel() {
                        var mobile = isBTBMobileViewport();
                        var nextMode = mobile ? 'mobile' : 'desktop';
                        if (btbMode === nextMode && $btbSlides.hasClass('slick-initialized')) {
                            return;
                        }
                        btbMode = nextMode;
                        destroyBTBCarousel();
                        if (mobile) {
                            isPausedByUser_3 = false;
                            pausedToggleIndex_3 = null;
                            initBTBMobile();
                        } else {
                            $btbMobileTrack.off('.btbMobile');
                            $btbMobileDots.off('.btbMobile');
                            initBTBDesktop();
                        }
                    }
    
                    routeBTBCarousel();
    
                    var btbResizeTimer;
                    $(window).on('resize', function() {
                        clearTimeout(btbResizeTimer);
                        btbResizeTimer = setTimeout(routeBTBCarousel, 200);
                    });
  });
})(jQuery);
